import { render, staticRenderFns } from "./PanelAlternativesManager.vue?vue&type=template&id=38fa7a22"
import script from "./PanelAlternativesManager.vue?vue&type=script&lang=ts"
export * from "./PanelAlternativesManager.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports